export var Iterators;
(function (Iterators) {
    function find(iterator, predicate) {
        for (const element of iterator) {
            if (predicate(element)) {
                return element;
            }
        }
        return undefined;
    }
    Iterators.find = find;
    function* filter(iterator, callbackFn) {
        for (const v of iterator) {
            if (callbackFn(v)) {
                yield v;
            }
        }
    }
    Iterators.filter = filter;
    function* map(iterator, callbackFn) {
        for (const v of iterator) {
            yield callbackFn(v);
        }
    }
    Iterators.map = map;
    function mapToArray(iterator, callbackFn) {
        return Array.from(map(iterator, callbackFn));
    }
    Iterators.mapToArray = mapToArray;
})(Iterators || (Iterators = {}));
//# sourceMappingURL=iterators.js.map